import React from 'react';
import Dialog from 'components/core';

const AlertCtx = React.createContext({
    show: (title, text, cancellable, onConfirm) => {}
});

function AlertCtxProvider(props)
{
    // TODO: Create alert dialog
    const [stack, setStack] = React.useState([]);

    const show = React.useCallback(function showAlert(title, text, warning, cancellable, onConfirm)
    {
        
    }, [stack]);


    return <AlertCtx.Provider value={{show: show}}>
        {props.children}
        </AlertCtx.Provider>
}

const FileViewerCtx = React.createContext({
    data: {
        showing: undefined,
        files: [],
        apiFileEndpoint: null,
        apiRequestParams: null
    },
    setShowing: () => {},
    setFiles: () => {},
    setApiFileEndpoint: () => {},
    setData: () => {}
});

function FileViewerCtxProvider(props)
{
    function setShowing(showing, apiFileEndpoint = null, apiRequestParams = null)
    {
        let newData = {...fileViewerData, showing: showing};
        if(apiFileEndpoint) newData = {...newData, apiFileEndpoint: apiFileEndpoint};
        if(apiRequestParams) newData = {...newData, apiRequestParams: apiRequestParams};
        setFileViewerData(newData);
        console.log("setting showing");
    }

    function setFiles(files)
    {
        setFileViewerData({...fileViewerData, files: files});
        console.log("setting files");
    }

    function setApiFileEndpoint(apiFileEndpoint, apiRequestParams = [])
    {
        setFileViewerData({...fileViewerData, apiFileEndpoint: apiFileEndpoint, apiRequestParams: apiRequestParams});
        console.log("setting API params: ");
        console.log(apiRequestParams);
    }

    function setData(files, apiFileEndpoint, apiRequestParams = [])
    {
        setFileViewerData({...fileViewerData, files: files, apiFileEndpoint: apiFileEndpoint, apiRequestParams: apiRequestParams});
    }

    const [fileViewerData, setFileViewerData] = React.useState({showing: undefined, files: [], apiFileEndpoint: null, apiRequestParams: []});

    return <FileViewerCtx.Provider value={{data: fileViewerData, setShowing: setShowing, setFiles: setFiles, setApiFileEndpoint: setApiFileEndpoint, setData: setData}} >
        {props.children}
        </FileViewerCtx.Provider>
}


export {FileViewerCtx, FileViewerCtxProvider};